import type { ModalProps } from "../../utils";
import styles from "./ErrorNotify.module.scss";
import { useTabs } from "../../components/Tabs/TabsProvider";
import { useTranslation } from "react-i18next";

const ErrorNotify: React.FC<ModalProps> = ({ onClose, errorMessage, primaryButtonText, primaryButtonAction, subErrorText }) => {
	const { t } = useTranslation('modals');
	const defaultErrorMessage = t("something_went_wrong");
	const { setActiveTab } = useTabs();

	const handleCloseModal = () => {
		setActiveTab("appearance");
		onClose();
	};

	return (
		<div className={`${styles.content} ${subErrorText ? styles.subError : ""}`}>
			{primaryButtonText && primaryButtonAction && <button className={styles.buttonClose} type="button" onClick={handleCloseModal} />}
			<div className={styles.text}>
				<h2>{(errorMessage && t("prompt_policy_violation")) || t("error")}</h2>
				<span>{subErrorText || defaultErrorMessage}</span>
			</div>
			{primaryButtonText && primaryButtonAction ? (
  				<button className={styles.button} type="button" onClick={primaryButtonAction}>
      					{primaryButtonText}
    			</button>
			) : (
  				<button className={styles.button} type="button" onClick={onClose}>
    				{t("try_again")}
  				</button>
			)}
		</div>
	);
};

export default ErrorNotify;
